var _path, _path2, _circle, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddHealthcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 82,
    viewBox: "0 0 91 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7 8.00022C57.6017 8.00022 48.541 7.86304 42.5005 14.4475C36.3228 7.86304 27.3994 8.00022 26.3011 8.00022C2.82568 8.00022 2.00198 31.0457 2.00198 31.32C1.72742 61.2242 40.9904 79.3313 41.4023 79.4685C41.8141 79.6057 42.0887 79.7429 42.5005 79.7429C42.9124 79.7429 43.3242 79.6057 43.5988 79.4685C44.0107 79.3313 83.2737 61.2242 82.9991 31.32C82.9991 31.0457 82.1754 8.00022 58.7 8.00022Z",
    fill: "#e2d1fa",
    stroke: "#090927",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 42.5H29.8005L36.7339 30L45.4005 54L52.7672 40.5H61.0005",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5005,
    cy: 14.5,
    r: 13,
    fill: "white",
    stroke: "#090927",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.0005,
    y: 8,
    width: 3,
    height: 13,
    rx: 1.5,
    fill: "#090927"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0005,
    y: 16,
    width: 3,
    height: 13,
    rx: 1.5,
    transform: "rotate(-90 70.0005 16)",
    fill: "#090927"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHealthcare);
export default __webpack_public_path__ + "static/media/add-healthcare.25c7a4138bb307851ef4c87d5a723762.svg";
export { ForwardRef as ReactComponent };